export const getPageType = ({ routeName }) => {
  const match = routeName.match(/^([a-z]+)s-.*/i)
  let result = null
  if (match) {
    result = match[1]
  }
  return result
}
